import axios from 'axios'
import { ADMIN_URL } from 'shared/app-settings';
const access_token = localStorage.getItem('access_token');

const ThiTrucTuyenService = {
    getdetailexam(body) {
        return axios.get(ADMIN_URL + 'laycauhoi', {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    getdetailquestion(id, userId, attemptCode = null) {
        let body = {
            id: id,
            userId: userId
        }
        // Chỉ gửi attempt_code nếu có (để backend check Redis)
        if (attemptCode) {
            body.attempt_code = attemptCode;
        }
        return axios.get(ADMIN_URL + `detailcauhoi`,
            {
                params: body,
                headers: {
                    Authorization: `${access_token}`
                },

            });
    },

    getquestionbyidnhom(id, userId, thitructuyen, attemptCode = null) {
        let body = {
            id: id,
            userId: userId,
            isthitructuyen: thitructuyen
        }
        // Chỉ gửi attempt_code nếu có (để backend check Redis)
        if (attemptCode) {
            body.attempt_code = attemptCode;
        }
        return axios.get(ADMIN_URL + `getcauhoibyidnhom`, {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    getoverviewexam(body) {
        return axios.get(ADMIN_URL + `dethitructuyen/overviewexam`, {
            params: body,
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    submitquestion(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestion', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    submitquestiontuluan(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestiontuluan', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    submitquestionsx(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestionsx', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    submitquestionsxbh(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestionsxbh', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    submitquestiontf(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestiontf', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    submitquestionmulti(body) {
        return axios.post(ADMIN_URL + 'dethitructuyen/submitquestionmulti', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    clearndata(body) {
        return axios.post(ADMIN_URL + 'clearndata', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    getidde() {
        return axios.get(ADMIN_URL + 'getidde', {
            headers: {
                Authorization: `${access_token}`
            },
        });
    },

    addthongtinuser(body) {
        return axios.post(ADMIN_URL + 'addthongtinuser', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    updatethongtinuser(body) {
        return axios.post(ADMIN_URL + 'updatethongtinuser', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    checkattempt(body) {
        return axios.get(ADMIN_URL + 'checkattempt', {
            params: body,
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    checkResumeAttempt(body) {
        return axios.post(ADMIN_URL + 'checkresumeattempt', body, {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    uploadFile(file, bucketType = 'exam', prefix = '') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('bucket_type', bucketType);
        if (prefix) {
            formData.append('prefix', prefix);
        }
        return axios.post(ADMIN_URL + 'fileupload/single', formData, {
            headers: {
                Authorization: `${access_token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteFile(bucketType, key) {
        // Axios DELETE với params cần encode đúng cách
        const params = new URLSearchParams();
        params.append('bucket_type', bucketType);
        params.append('key', key);

        return axios.delete(ADMIN_URL + 'fileupload/delete?' + params.toString(), {
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    listFiles(bucketType, prefix = '', maxKeys = 100) {
        return axios.get(ADMIN_URL + 'fileupload/list', {
            params: {
                bucket_type: bucketType,
                prefix: prefix,
                max_keys: maxKeys
            },
            headers: {
                Authorization: `${access_token}`
            }
        });
    },
    getExamHistory(userId, dethiId = null) {
        const params = {
            user_id: userId,
            typeExam: '', // Không truyền typeExam để lấy tất cả
            isthitructuyen: 1
        };
        if (dethiId) {
            params.IdDeThi = dethiId;
        }
        return axios.get(ADMIN_URL + 'dethitructuyen/overviewexam', {
            params: params,
            headers: {
                Authorization: `${access_token}`
            }
        });
    },

    /**
     * Gửi bài Writing lên AI để chấm điểm.
     * Gọi sau khi updatethongtinuser hoàn thành (dữ liệu đã sync về DB).
     * @param {string|number} userId
     * @param {string} attemptCode
     * @param {string} typeExam  (mặc định 'VIET')
     * @returns Promise — fire & forget, không cần await kết quả
     */
    submitWritingAI(userId, attemptCode, typeExam = 'VIET') {
        return axios.get(ADMIN_URL + 'AiExam/submitWriting', {
            params: { userId, attemptCode, typeExam },
            headers: { Authorization: `${access_token}` },
            timeout: 90000  // 90s — AI processing có thể chậm
        });
    },

    /**
     * Gửi bài Speaking lên AI để chấm điểm.
     * Gọi sau khi updatethongtinuser hoàn thành (dữ liệu đã sync về DB).
     * @param {string|number} userId
     * @param {string} attemptCode
     * @param {string} typeExam  (mặc định 'NOI')
     * @returns Promise — fire & forget, không cần await kết quả
     */
    submitSpeakingAI(userId, attemptCode, typeExam = 'NOI') {
        return axios.get(ADMIN_URL + 'AiExam/submitSpeaking', {
            params: { userId, attemptCode, typeExam },
            headers: { Authorization: `${access_token}` },
            timeout: 90000  // 90s
        });
    },

    /**
     * Lấy kết quả chấm Writing từ AI và cập nhật điểm.
     * @param {string} requestId  UUID trả về từ submitWritingAI
     * @param {boolean} updateScore  true = cập nhật điểm vào DB
     */
    getWritingResult(requestId, updateScore = true) {
        return axios.get(ADMIN_URL + 'AiExam/getWritingResult', {
            params: { requestId, updateScore: updateScore ? 1 : 0 },
            headers: { Authorization: `${access_token}` }
        });
    },

    /**
     * Lấy kết quả chấm Speaking từ AI và cập nhật điểm.
     * @param {string} requestId  UUID trả về từ submitSpeakingAI
     * @param {boolean} updateScore  true = cập nhật điểm vào DB
     */
    getSpeakingResult(requestId, updateScore = true) {
        return axios.get(ADMIN_URL + 'AiExam/getSpeakingResult', {
            params: { requestId, updateScore: updateScore ? 1 : 0 },
            headers: { Authorization: `${access_token}` }
        });
    },

    getreviewexam(attemptCode, typeExam, userId, dethiId) {
        return axios.get(ADMIN_URL + 'ReviewThi/detail', {
            params: {
                attempt_code: attemptCode,
                typeExam: typeExam,
                userId: userId,
                dethiId: dethiId
            },
            headers: {
                Authorization: `${localStorage.getItem('access_token')}`
            }
        });
    },
    getPublicOverviewExam(userId, dethiId = null) {
        return axios.get(ADMIN_URL + 'public/result/overview', {
            params: {
                user_id: userId,
                isthitructuyen: 1,
                IdDeThi: dethiId
            }
            // Không gửi Authorization header
        });
    },
    getPublicReviewExam(attemptCode, typeExam, userId, dethiId = null) {
        return axios.get(ADMIN_URL + 'public/review/detail', {
            params: {
                attempt_code: attemptCode,
                typeExam: typeExam,
                userId: userId,
                dethiId: dethiId
            }
        });
    },
}
export { ThiTrucTuyenService };